import {
  call, put, takeEvery, select,
} from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import { showErrorNotification } from 'store/shared/actions';
import {
  getBarcodeItemsFilters,
} from 'store/barcode-items/selectors';
import { FILTER_KEYS } from './fixtures';
import * as constants from './constants';
import * as actions from './actions';
import { resetUpdatedItems } from '../items/actions';

export function* getBarcodeItems() {
  try {
    const {
      [FILTER_KEYS.HAS_MORE]: hasMore,
      [FILTER_KEYS.PAGE]: page,
      // [FILTER_KEYS.SORT_DIRECTION]: direction,
      ...query
    } = yield select(getBarcodeItemsFilters);
    const currentPage = hasMore ? page + 1 : 1;
    const params = {
      query: {
        ...query,
        [FILTER_KEYS.PAGE]: currentPage,
      },
    };
    const { data } = yield call(request, API.BARCODE_ITEMS, 'GET', params);

    yield put(actions.getBarcodeItemsSuccess({
      data,
      filters: {
        ...query,
        [FILTER_KEYS.PAGE]: currentPage,
        [FILTER_KEYS.HAS_MORE]: data.length > 0 && query[FILTER_KEYS.PER_PAGE] === data.length,
      },
    }));

    if(currentPage === 1) {
      resetUpdatedItems();
    }
  } catch (e) {
    yield put(actions.getBarcodeItemsError(e));
    yield put(showErrorNotification({ message: 'Failed to fetch data, please try later.' }));
  }
}
// eslint-disable-next-line import/prefer-default-export
export function* getBarcodeItemsWatcher() {
  yield takeEvery(constants.GET_BARCODE_ITEMS, getBarcodeItems);
}

export function* validateBarcodeItem(action) {
  try {
    const { data } = yield call(request, API.BARCODE_ITEMS_VALIDATE, 'GET', { query: { barcode: action.payload.barcode } });

    if(Array.isArray(data?.items)) {
      yield put(actions.validateBarcodeItemSuccess(data?.items));
    } else {
      yield put(actions.validateBarcodeItemError());
    }
  } catch (e) {
    yield put(actions.validateBarcodeItemError());
  }
}

export function* validateBarcodeItemWatcher() {
  yield takeEvery(constants.VALIDATE_BARCODE_ITEM, validateBarcodeItem);
}

export function* searchBarcodeItem(action) {
  try {
    // todo - replace with correct api end point when available
    const { data } = yield call(request, API.BARCODE_ITEMS_SEARCH, 'GET', {
      query: {
        query: action.payload.barcode,
        limit: 1,
        offset: 1,
        page: 1,
      },
    });

    if(data?.[0]) {
      yield put(actions.searchBarcodeItemSuccess(data?.[0]));
    } else {
      yield put(showErrorNotification({ message: 'Item not found' }));
      yield put(actions.searchBarcodeItemError());
    }
  } catch (e) {
    yield put(actions.validateBarcodeItemError());
  }
}

export function* searchBarcodeItemWatcher() {
  yield takeEvery(constants.SEARCH_BARCODE_ITEM, searchBarcodeItem);
}
